module.exports = __webpack_public_path__ + "fasaw4.png?9fc6baa902ffc770011d827cb4d3b334";